import { render, staticRenderFns } from "./Usermanagement.vue?vue&type=template&id=2f7efcdd&scoped=true&"
import script from "./Usermanagement.vue?vue&type=script&lang=js&"
export * from "./Usermanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7efcdd",
  null
  
)

export default component.exports